<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size:24px!important">CRIME REPORT ANALYTICS</h4>
        </div>
        <!-- <div class="flex md6 sm6 xs12">
          <fieldset>
            <va-toggle    class="justify--end" v-model="toggles.selected" small label="Customize" />
          </fieldset>
        </div>-->
      </div>
      <nav style="height:70px!important" class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="row">
          <div v-if="!toggles.selected" class="flex md10 sm6 xs12 row">
            <div class="flex md4 offset--md3 sm6 xs12">
              <div class="form-group" style="padding-top:20px!important">
                <label for="exampleInputEmail1" style="text-align: left!important;"></label>
                <select v-model="type" class="filter pt-2 pb-2">
                  <option value selected disabled hidden>Choose for Customized Reports</option>
                  <option value=" ">All</option>
                  <option value="today">Today</option>
                  <option value="thisweek">This Week</option>
                  <option value="thismonth">This Month</option>
                   <option value="lastsixmonth">Last Six Months</option>
                    <option value="thisyear">This Year</option>
                </select>
              </div>
            </div>
            <div class="flex md3 sm6 xs12"></div>
          </div>
          <div class="flex md10 sm6 xs12 row" v-else>
            <div style="padding-top:35px" class="flex md4 offset--md1 sm6 xs12">
              <va-date-picker
                style="background-color:#F8F9FA!important;width:100%!important"
                placeholder="Click to Select Start Date"
                v-model="fromDate"
                :config="{dateFormat: 'd-M-Y'}"
                name="uniquename"
              ></va-date-picker>
            </div>
            <div class="flex md1 offset sm6 xs12"></div>
            <div style="padding-top:35px" class="flex md4 sm6 xs12">
              <va-date-picker
                class="filter"
                style="color:black!important;"
                placeholder="Click to Select end Date"
                v-model="toDate"
                :config="{dateFormat: 'd-M-Y'}"
                name="uniquename"
              ></va-date-picker>
            </div>
          </div>
          <div style="padding-top:35px" class="flex md2 sm6 xs12">
            <fieldset>
              <va-toggle
                @click="func"
                class="justify--end"
                v-model="toggles.selected"
                small
                label
              />
            </fieldset>
          </div>
        </div>
      </nav>
      <div style="padding-top:15px;">
        <b-card no-body>
          <b-tabs v-model="tabIndex" card>
            <b-tab
              v-if="this.chartOptions2.xaxis.categories.length>0 && this.series2[0].data.length>0"
              title="Crimes Reported by Users"
              :title-link-class="linkClass(0)"
            >
              <apexchart
                v-if="afterLoad1"
                type="line"
                height="350"
                :options="chartOptions2"
                :series="series2"
              />
            </b-tab>
            <b-tab
              v-if="this.chartOptions3.xaxis.categories.length>0"
              title="Crimes Reported by Guests"
              :title-link-class="linkClass(1)"
            >
              <apexchart
                v-if="afterLoad"
                type="line"
                height="350"
                :options="chartOptions3"
                :series="series3"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
      <div style="padding-top:20px" class="row">
        <div class="flex md6 sm6 xs12" id="chart">
          <va-card style="min-height:480px!important">
            <h5 style="text-align:center;">Crime Report Status</h5>
            <apexchart style="padding-top:15px" type="pie" :options="chartOptions" :series="series"></apexchart>
          </va-card>
        </div>
        <div v-if="this.skey.length>0" class="flex md6 sm6 xs12">
          <va-card style="min-height:480px!important">
            <h5 style="text-align:center">Sources (Online Level)</h5>
            <apexchart
              style="padding-top:15px"
              type="pie"
              :options="chartOptions1"
              :series="series1"
            ></apexchart>
          </va-card>
        </div>
        <div v-if="this.ckey.length>0" class="flex md6 sm6 xs12">
          <va-card style="min-height:480px!important">
            <h5 style="text-align:center">Crime Types</h5>
            <apexchart
              style="padding-top:15px"
              type="pie"
              :options="chartOptions4"
              :series="series4"
            ></apexchart>
          </va-card>
        </div>
      </div>
    </va-card>
  </div>
</template>
<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import Datepicker from 'vuejs-datepicker'
export default {
  components: {
    VueElementLoading,
    Datepicker,
  },
  data () {
    return {
      userCRgraph: [],
      guestCRgraph: [],
      skey: [],
      ckey: [],
      demo: [],
      crimeimeTypeCR: [],
      sourceCR: [],
      tabIndex: 0,
      data: [],
      data1: [],
      data2: [],
      afterLoad1: false,
      afterLoad: false,
      visible: false,
      type: '',
      fromDate: '',
      toDate: '',
      series3: [
        {
          name: 'No.of Crimes',
        },
      ],
      toggles: {
        selected: false,
      },
      chartOptions3: {
        chart: {
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: 'Crimes Reported by Guests',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      series2: [
        {
          name: 'No.of Crimes',
        },
      ],
      chartOptions2: {
        chart: {
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: 'Crimes Reported by Users',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
        },
        labels: [
          'Pending Reports ',
          'Completed Reports',
          'Disposed Reports',
          'Solved Reports',
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: '65%',
                  },
                },
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      series1: [],
      chartOptions1: {
        chart: {
          type: 'pie',
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              plotOptions: {
                pie: {},
              },
              legend: {
                position: 'top',
              },
            },
          },
        ],
      },
      series4: [],
      chartOptions4: {
        chart: {
          type: 'pie',
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: '85%',
                  },
                },
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      // usere
    }
  },

  watch: {
    type: function () {
      this.fromDate = ''
      this.toDate = ''
      this.data1 = []
      this.chartOptions3.xaxis.categories = []
      this.chartOptions2.xaxis.categories = []
      this.analyticsuser()
    },

    fromDate: function () {
      this.data1 = []
      this.chartOptions3.xaxis.categories = []
      this.chartOptions2.xaxis.categories = []
      this.analyticsuser()
    },
    toDate: function () {
      this.data1 = []
      this.chartOptions3.xaxis.categories = []
      this.chartOptions2.xaxis.categories = []
      this.analyticsuser()
    },
  },
  mounted: function () {
    this.analyticsuser()
  },
  methods: {
    func () {
      this.analyticsuser()
    },
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },

    analyticsuser () {
      this.visible = true
      var analytics = {}
      if (this.type !== '') analytics['type'] = this.type
      if (this.fromDate !== '') analytics['fromDate'] = this.fromDate
      if (this.toDate !== '') analytics['toDate'] = this.toDate
      axios({
        method: 'POST',
        data: analytics,
        headers: {
          token: localStorage.getItem('token'),
        },
        url: '/admin/detailed/analytics',
      }).then(response => {
        this.visible = false
        this.afterLoad1 = true
        this.data = response.data.count
        this.sourceCR = response.data.count.sourceCR
        this.crimeTypeCR = response.data.count.crimeTypeCR

        // Reports Status
        this.data1[0] = response.data.count.pendingCR
        this.data1[2] = response.data.count.disposedCR
        this.data1[3] = response.data.count.solvedCR
        this.data1[1] = response.data.count.completedCR
        this.series = this.data1
        this.userCRgraph = response.data.graph.userCRgraph
        // this.demo.push(this.sourceCR);

        // Sources

        const sourceCRKey = Object.keys(Object.assign({}, ...this.sourceCR))
        const sourceCRValue = Object.values(
          Object.assign({}, ...this.sourceCR)
        )
        this.series1 = sourceCRValue
        this.chartOptions1.labels = sourceCRKey
        this.skey = sourceCRKey

        // Crime Types

        const crimeTypeCRKey = Object.keys(
          Object.assign({}, ...this.crimeTypeCR)
        )
        const crimeTypeCRValue = Object.values(
          Object.assign({}, ...this.crimeTypeCR)
        )
        this.series4 = crimeTypeCRValue
        this.ckey = sourceCRKey
        this.chartOptions4.labels = crimeTypeCRKey
        // user
        var res1 = []
        var xaxisdata1 = []
        var yaxisdata1 = []
        this.visible = false
        this.afterLoad1 = true
        for (var i = 0; i < this.userCRgraph.length; i++) {
          res1.push({
            x: this.userCRgraph[i].x,
            y: this.userCRgraph[i].y,
          })
          xaxisdata1.push(
            this.userCRgraph[i].x.replace('T', ', ').slice(0, 17)
          )
          yaxisdata1.push(Number(this.userCRgraph[i].y))
        }
        this.chartOptions2.xaxis.categories = xaxisdata1
        this.series2[0].data = yaxisdata1
        this.analy = res1
        // guest
        var res = []
        var xaxisdata = []
        var yaxisdata = []
        this.afterLoad = true
        for (var j = 0; j < response.data.graph.questCRgraph.length; j++) {
          res.push({
            x: response.data.graph.questCRgraph[j].x,
            y: response.data.graph.questCRgraph[j].y,
          })
          xaxisdata.push(
            response.data.graph.questCRgraph[j].x
              .replace('T', ', ')
              .slice(0, 17)
          )
          yaxisdata.push(Number(response.data.graph.questCRgraph[j].y))
        }
        this.chartOptions3.xaxis.categories = xaxisdata
        this.series3[0].data = yaxisdata
        this.analy = res
      })
      // .catch(error => {
      //   this.visible = false
      //   console.log(error)
      // })
    },
    updateSeriesLine () {
      this.$refs.realtimeChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
        ],
        false,
        true
      )
    },
  },
}
</script>
<style scoped>
.card {
  box-shadow: 0px 0px 0px 0px #707070 !important;
}
.filter {
  width: 100% !important;
}
.va-toggle__track {
  background-color: blue !important;
}
</style>
